<template>
 <li
    v-show="visible"
    @click.stop="_selectOptionClick"
    class="mc-dropdown__option"
    :class="{
      'selected' : false,
      'disabled' : disabled
    }"
    >
   <slot>
     <span>{{currentLabel}}</span>
   </slot>
 </li>
</template>
<script type="text/ecmascript-6">
  import Emitter from '../mixins/emitter'
  export default {
    mixins: [Emitter],
    name: 'base-select-option',
    inject:['select'],
    props: {
        value: {
        required: true
        },
        created: Boolean,
        label: [String, Number],
        index: [String, Number],
        item: [Object, String, Number],
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
      return {
          visible: true,

      }
    },

    computed: {
      currentLabel(){
        return this.label || this.value || ''
      },
      currentValue() {
        return this.value || this.label || '';
      },


    },
    watch: {

    },
    methods: {
        queryChange(query) {
            // query 里如果有正则中的特殊字符，需要先将这些字符转义
            let parsedQuery = String(query).replace(/(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g, '\\$1');
            this.visible = new RegExp(parsedQuery, 'i').test(this.currentLabel) || this.created;
            if (!this.visible) {
                this.select.filteredOptionsCount--;
            }
        },
      _selectOptionClick(){
          if(this.disabled){return}
        this.dispatch('base-select', 'handleOptionClick', this);
      }
    },
    created(){
      this.select.options.push(this);
      this.select.cachedOptions.push(this);

        this.select.filteredOptionsCount++;

        this.$on('queryChange', this.queryChange);
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/base-select-option.vue